module.exports = __webpack_public_path__ + "img/logo.bad49077.svg";